import React from "react"
import { Box, Heading, Tooltip, VStack } from "@chakra-ui/react"


export default function SkillItem({ category, skills }) {
    return (
        <Box>
            <Heading as="h3" fontSize={34} mb={4}>{category}</Heading>
            <VStack align="start" spacing={5}>
                {skills.map((skill, i)  => {
                    return (
                        <Tooltip key={i}  boxShadow="sm" label={skill.description} bg="white" borderRadius={20} color="black" fontSize={18} py={8} px={10}>
                            <Heading key={i} as="h4" fontSize={24} color="gray.400" fontWeight={600} cursor="pointer" _hover={{ color: 'black' }}>
                                {skill.name}
                            </Heading>
                        </Tooltip>
                    )
                })}
            </VStack>
        </Box>
    )
}
